import React from 'react'
import { Typography, makeStyles } from '@material-ui/core'
import { Box, Link } from '@mui/material'
import { useHistory } from 'react-router-dom'
const NotFound = () => {
  const history = useHistory()
  const classes = useStyles()
  return (
    <Box className={classes.notFound}>
      <Box className={classes.errorBox}>
        <Typography variant="h4">Oops!</Typography>
        <Box className={classes.msgBox}>
          <Typography variant="h6" className={classes.errMsg}>
            The page you&apos;re trying to reach isn&apos;t available or can&apos;t be found.
          </Typography>
        </Box>
        <Box>
          <Link className={classes.link} onClick={() => history.goBack()}>
            Go Back
          </Link>
        </Box>
      </Box>
    </Box>
  )
}

export default NotFound

const useStyles = makeStyles({
  notFound: {
    marginTop: '5rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  msgBox: {
    marginTop: '10px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  errorBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px'
  },
  link: {
    display: 'inline',
    cursor: 'pointer'
  }
})
